var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Jur-Cadastro-Principal"},[_c('PageTitle',{attrs:{"icon":"fa fa-group","main":"Administração","sub":"Juridico / Contrato / Financeiro"}}),_c('div',{staticClass:"Adm-Juridico-Principal"},[_c('b-card',{attrs:{"no-body":""}},[_c('b-tabs',[_c('b-tab',{attrs:{"title":"Juridico","active":""}},[_c('Juridico')],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }